import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { subscriber_profile_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { Author } from '../../interfaces/authors';
import AuthorTooltip from '../AuthorTooltip';

interface NameItemProps {
  author: Author;
  withTooltip?: boolean;
}

const NameItem = ({ author, withTooltip }: NameItemProps) => {
  const { Track, trackEvent } = useEventTracking({
    creatorIds: [author.id],
  });

  return (
    <Track>
      <div className="group relative inline-block">
        <a
          href={subscriber_profile_path(author.username)}
          className="author-name text-black transition-colors duration-200 hover:text-primary-magenta"
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.Author, clickText: author.name }))
          }
        >
          {author.name}
        </a>
        {withTooltip && (
          <AuthorTooltip
            email={author.email}
            profileEnabled={author.profileEnabled}
            twitter={author.twitter}
            username={author.username}
          />
        )}
      </div>
    </Track>
  );
};

export default NameItem;
